import styled from 'styled-components'

export const Wrapper = styled.div`
  z-index: 1;
  position: relative;
`

export const Label = styled.span`
  font-size: 12px;
  color: ${({ theme, index }) =>
    index === 0 ? theme.colors.neutralW70 : theme.colors.neutralW90};

  &:first-child a {
    text-decoration: underline;
  }
`

export const Separator = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.neutralW90};
`
